module.exports = __webpack_public_path__ + "img/policeTraining.855374d4.png";